import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { ExportService } from './export.service';

angular.module('app-lite.export', [])
  .service('exportApi', downgradeInjectable(ExportService));
